import type { FaireProductEntity } from "../../entity_types/product";

export const p_m9dprzujwc: FaireProductEntity = {
  token: "p_m9dprzujwc",
  type: "product",
  name: "Canvas Tote, Tomatoes are the Best",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/f0ab09c4db8350cef14447568f5041242b31af4d75dd9f14a1405713cd9fc997.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4348f43380dc6566603e2cac0d7726b6e3ff21413fa9817927b397082a02506e.jpeg",
    "https://cdn.faire.com/fastly/1a62f4ca15b14fa340297efe9bd25d6f2e7c70c66d0d431318bcbe8bfc013cab.jpeg"
  ],
  priceDollars: 11,
  description: "You have a statement to make—and it’s definitely about tomatoes. This cool canvas tote features a double-sided design and an interior pocket for your essentials. Whether you’re hitting the farmers market, the bookstore, or brunch, this bag brings the flavor and the function.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n\n• Made with durable cotton canvas\n• Double-sided tomato design for extra style\n• Includes an interior pocket for small essentials\n• Roomy and lightweight—perfect for daily use\n• Designed in Bando’s signature bright and playful style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫:\n\n• Gift shops and lifestyle boutiques\n• Fashion and accessory retailers\n• Market shoppers, students, and everyday commuters\n• Wholesale buyers seeking fun, functional statement totes",
  tags: [],
  msrpDollars: 22.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:15.346Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
